// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import categoryApi from '~/apis/category';
import { GET_LIST_CATEGORY } from '~/utils/constants/actionType';
import { IQueryGetListCategory } from '~/utils/interface/category';

export const getListCategory = createAsyncThunk(
  GET_LIST_CATEGORY,
  async (params: IQueryGetListCategory, { rejectWithValue }) => {
    try {
      const resp = await categoryApi.getListCategory(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
